import { ResponsiveContainer, ComposedChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine } from "recharts";
import { fmtDate } from "@/lib/status";

const TipBox = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-md border border-border bg-[#0B0F17]/95 px-3 py-2 text-xs">
      <p className="font-mono text-slate-400">{fmtDate(d.tanggal)}</p>
      <p className="text-sky-300">Rencana: {d.rencana}%</p>
      {d.realisasi !== null && <p className="text-emerald-300">Realisasi: {d.realisasi}%</p>}
    </div>
  );
};

// Sumbu X harian: ~128 titik, label tiap tanggal tidak muat — tampilkan sekitar 6 label saja.
const tickTanggal = (v) => fmtDate(v).replace(/ \d{4}$/, "");
const TICK_INTERVAL = (total) => Math.max(1, Math.floor(total / 6));

export const SCurveChart = ({ data }) => {
  const today = [...data].reverse().find((d) => d.realisasi !== null)?.tanggal;
  return (
    <div className="h-80 w-full" data-testid="s-curve-chart">
      <ResponsiveContainer>
        <ComposedChart data={data} margin={{ top: 10, right: 16, left: -10, bottom: 0 }}>
          <defs>
            <linearGradient id="planFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#0EA5E9" stopOpacity={0.25} />
              <stop offset="100%" stopColor="#0EA5E9" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#1C273B" strokeDasharray="3 3" />
          <XAxis dataKey="tanggal" stroke="#64748B" fontSize={11} tickFormatter={tickTanggal} interval={TICK_INTERVAL(data.length)} minTickGap={8} />
          <YAxis stroke="#64748B" fontSize={11} domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
          <Tooltip content={<TipBox />} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {today && <ReferenceLine x={today} stroke="#F59E0B" strokeDasharray="4 4" label={{ value: "Hari ini", fill: "#F59E0B", fontSize: 11, position: "top" }} />}
          <Area type="monotone" dataKey="rencana" name="Rencana" stroke="#0EA5E9" strokeWidth={2} fill="url(#planFill)" />
          {/* dot dimatikan karena deretnya harian dan titiknya rapat — kecuali di awal proyek,
              di mana satu-dua titik tanpa dot tidak tergambar sama sekali. */}
          <Line type="monotone" dataKey="realisasi" name="Realisasi" stroke="#10B981" strokeWidth={3}
            dot={data.length < 3 ? { r: 3, fill: "#10B981", strokeWidth: 0 } : false}
            activeDot={{ r: 4 }} connectNulls={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};
